import { createReducer, on } from "@ngrx/store";
import { initialUserState, UserState } from "./user.state";
import { UserActions } from "./user.actions";

// **************************************************************************
// USER REDUCER (standalone feature store)
// **************************************************************************

export const userReducer = createReducer(
    initialUserState,

    on(UserActions.initializeUser, (state): UserState => ({
        ...state,
        error: null,
        loading: true,
    })),

    on(UserActions.initializeUserSuccess, (state, { user, selectedCompany }): UserState => ({
        ...state,
        user,
        selectedCompany,
        loading: false,
    })),

    on(UserActions.initializeUserFailure, (state, { error }): UserState => ({
        ...state,
        error,
        loading: false,
    })),

    on(UserActions.changeLanguage, (state, { language }): UserState => ({
        ...state,
        user: state.user ? { ...state.user, siteLanguageCode: language } : null,
    })),

    on(UserActions.updateUserLanguageSuccess, (state, { language }): UserState => ({
        ...state,
        user: state.user ? { ...state.user, siteLanguageCode: language } : null,
    })),

    on(UserActions.changeCompanySuccess, (state, { company }): UserState => ({
        ...state,
        selectedCompany: company,
    })),

    on(UserActions.updatePhoneNumberSuccess, (state, { phoneNumber }): UserState => ({
        ...state,
        user: state.user ? { ...state.user, phoneNumber } : null,
    })),

    on(UserActions.updatePhoneNumberFailure, (state, { error }): UserState => ({
        ...state,
        error,
    })),

    on(UserActions.updateDefaultSendQuoteToSelfSuccess, (state, { defaultSendQuoteToSelf }): UserState => ({
        ...state,
        user: state.user ? { ...state.user, defaultSendQuoteToSelf } : null,
    })),

    on(UserActions.updateDefaultSendQuoteToSelfFailure, (state, { error }): UserState => ({
        ...state,
        error,
    })),
);
